<!-- 畅销商品报表 -->
<template>
  <div>
    <quickSelectDate></quickSelectDate>
  </div>
</template>
<script>
import quickSelectDate from '@/components/quickSelectDate.vue';
export default {
  components: {
    quickSelectDate
  }
}
</script>
<style lang="less" scoped>

</style>